import { Site } from '@envato/foundation-types'
import * as React from 'react'

import HoverFocusObserver from '../hoverFocusObserver'
import AudioJungleItemCard from './audioJungleItemCard'
import CodeCanyonItemCard from './codeCanyonItemCard'
import GraphicRiverItemCard from './graphicRiverItemCard'
import PhotoduneGridItemCard from './photoduneGridItemCard/photoduneItemCardContainer'
import ThemeForestItemCard from './themeForestItemCard'
import VideoHiveItemCard from './videoHiveItemCard/videoHiveItemCardContainer'
import WithItemDecorator from '../../containers/withItemDecorator'

import { IProps } from './itemCardContainer'
import { IItemCard } from './interface'

interface IItemCardContent extends IItemCard {
  currentSite: Site
  index: number
}

const ItemCardContent = ({ currentSite, ...props }: IItemCardContent) => {
  if (currentSite === Site.photodune) {
    return <PhotoduneGridItemCard {...props} />
  } else if (currentSite === Site.graphicriver) {
    return <GraphicRiverItemCard {...props} />
  } else if (currentSite === Site.threedocean) {
    return <GraphicRiverItemCard {...props} />
  } else if (currentSite === Site.audiojungle) {
    return <AudioJungleItemCard {...props} />
  } else if (currentSite === Site.videohive) {
    return <VideoHiveItemCard {...props} />
  } else if (currentSite === Site.codecanyon) {
    return <CodeCanyonItemCard {...props} />
  } else {
    return <ThemeForestItemCard {...props} />
  }
}

const ItemCard = ({ listName, index, item, ...props }: IProps) => (
  <WithItemDecorator
    listName={listName}
    render={itemDecorator => {
      const itemProps = itemDecorator(item, index)
      const nextProps = {
        ...props,
        ...itemProps
      }
      return (
        <HoverFocusObserver>
          {({ isHovered, isFocused }) => (
            <ItemCardContent
              index={index}
              isCardHovered={isHovered}
              isCardFocused={isFocused}
              {...nextProps}
            />
          )}
        </HoverFocusObserver>
      )
    }}
  />
)

export default ItemCard
